import { encryptFile, decryptFile } from '../core/aes'
import { createEncryptedFile } from './format'

/**
 * Encrypt file
 *
 * @param {String} id
 * @param {String} path
 * @param {String} service
 * @param {ArrayBuffer} data
 * @param {Base64UrlString} encryptionKey
 * @param {SymmetricEncryptionParams} encryptionParams
 * @return {EncryptedFile}
 * @throws {Error} if a parameter is invalid
 * @private
 */
export function encrypt (id, path, service, data, encryptionKey, encryptionParams) {
  return createEncryptedFile(id, path, service, encryptFile(data, encryptionKey, encryptionParams))
}

/**
 * Decrypt file
 *
 * @name decryptFile
 * @param {ArrayBuffer} data
 * @param {Base64UrlString} decryptionKey
 * @param {SymmetricEncryptionParams} decryptionParams
 * @return {ArrayBuffer}
 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
 * @public
  * @example
 *  const keys = CryptolizeCore.createAsymmetricKeys()
 *  const password = 'password'
 *  const hint = 'hint'
 *  const record = CryptolizeCore.encryptRecord(..., keys.public, ..., [{ password, hint }], ...)
 *  const header = CryptolizeCore.decryptRecord(record, keys.private)[0]
 *  const key = CryptolizeCore.decryptKeyWithSymmetricEncryption(password, header)
 *  const file = CryptolizeCore.decryptFile(record.blocks[0].files[0].data, key, header.filesEncryptionParams[0].encryptionParams)
 *  console.log(file)
*/
export const decrypt = decryptFile



// WEBPACK FOOTER //
// ./src/record/file.js